var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c("div", { staticClass: "trbo-a-spinner__gradient" }),
    _vm._v(" "),
    _c("div", { staticClass: "trbo-a-spinner__inner" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }